import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion } from "@mantine/core";
import { CodeDiff } from "../../components/CodeDiff.js";
import { CodeEditor } from "../../components/CodeEditor.js";
import { useAppSelector } from "../../hooks/redux.js";
import { getPrimaryVersionSpec, getSecondaryVersionSpec } from "../../utils/selectors.js";
import { format } from "@maplibre/maplibre-gl-style-spec";
export const VersionListItemPanel = () => {
    const primarySpec = useAppSelector(getPrimaryVersionSpec);
    const secondarySpec = useAppSelector(getSecondaryVersionSpec);
    return (_jsxs(Accordion.Panel, { children: [primarySpec && secondarySpec && (_jsx(CodeDiff, { value: format(primarySpec), original: format(secondarySpec) })), primarySpec && !secondarySpec && (_jsx(CodeEditor, { value: format(primarySpec) }))] }));
};
